import * as React from 'react';
import styled from 'styled-components';

import { getColor, getFontSize, getFontFamily } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 6px
`;

const Title = styled.div`
    font-size: ${getFontSize('smaller')};
    color: ${getColor('blue')};
    margin-bottom: 5px;
    align-items: center;
`;

type Props = {
    title: string;
}

export const Section: React.FC<Props> = ({
    title,
}) => (
    <Wrapper>
        <Title>{title}</Title>
    </Wrapper>
);
